import { axiosInstance } from './axios-instance'
import * as endpoints from '../constants/api-constants'

class DataPolicyService {
  static updatePolicy(payload, config) {
    return axiosInstance
      .put(endpoints.dataPolicy, payload, config)
      .then(res => res.data)
  }
  static getUserParticipationCampaign(concourseId, config) {
    return axiosInstance
      .get(`${endpoints.campaignUpdateData}/${concourseId}`, config)
      .then(res => res.data)
  }
}

export default DataPolicyService
